export default "__VITE_ASSET__bd986efb__"